import httpClient from '@/http-client'

export const summary = productId => {
  return httpClient
    .get(`/api/v1/product-profile-details/summaries/${productId}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const purchaseInvoice = (productId, Options = {}) => {
  return httpClient
    .get(`/api/v1/product-profile-details/purchase-invoices/${productId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const transfer = (productId, Options = {}) => {
  return httpClient
    .get(`/api/v1/product-profile-details/transfers/${productId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const saleInvoice = (productId, Options = {}) => {
  return httpClient
    .get(`/api/v1/product-profile-details/sale-invoices/${productId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const writeOff = (productId, Options = {}) => {
  return httpClient
    .get(`/api/v1/product-profile-details/write-off/${productId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const returnToVendor = (productId, Options = {}) => {
  return httpClient
    .get(`/api/v1/product-profile-details/return-to-vendors/${productId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const returnFromVendor = (productId, Options = {}) => {
  return httpClient
    .get(`/api/v1/product-profile-details/return-from-vendors/${productId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { 
  summary,
  purchaseInvoice,
  transfer,
  saleInvoice,
  writeOff,
  returnToVendor,
  returnFromVendor 
}
